import React from 'react';

import * as S from './BreadCrumbRefundRaise.styles';

const BreadCrumbRefundRaisePage = ({listData}) => {
  const redirectFunction = () => {
    window.open('/coreui/wallet/', '_self');
  };
  const doNothing = () => {
    return;
  };
  return (
    <S.CrumbList>
      {listData &&
        listData.length > 0 &&
        listData.map(item => (
          <li key={item.id}>
            <a onClick={item?.url ? redirectFunction : doNothing}>{item.text}</a>
          </li>
        ))}
    </S.CrumbList>
  );
};

export default BreadCrumbRefundRaisePage;
